import { createBrowserClient } from "@supabase/ssr";

// Singleton: один realtime-клиент на весь app. Один `realtime.setAuth(token)`
// в use-messenger-data автоматически распространяется на все каналы (deal sidebar,
// payments, deals, tasks, products, etc), потому что все читают этот же инстанс.
//
// Без синглтона нужно было бы устанавливать токен в каждом хуке отдельно.
let cached: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  if (!cached) {
    cached = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
    );
  }
  return cached;
}
